import { type FavoritePlace } from 'invictus-sdk-typescript'

import { type FavoritePlaces } from '@Components/container/search/searchCriteria/autocompleteFavoritePlaces/AutocompleteFavoritePlaces'

export const mapFavoritePlacesToAutocompleteFavoritePlaces = (favoritePlaces: FavoritePlace[]): FavoritePlaces =>
  favoritePlaces.reduce(
    (acc: FavoritePlaces, item: FavoritePlace) => {
      if (item.type === 'WORK') {
        acc.workFavoritePlace = item
      } else if (item.type === 'HOME') {
        acc.homeFavoritePlace = item
      } else {
        acc.otherFavoritePlaces?.push(item)
      }

      return acc
    },
    { otherFavoritePlaces: [] },
  )
